import React from "react";
import Wrp from "../../../../../hoc/Wrp/Wrp";
import { isShowPreferredCurrencyEnabled, formatExchangeRate } from "../../../../../Utils/CommonFunctions";

/** Same closed currency display as detail-view OthersField: amount + currency code + exchange rate badge. */
const CurrencyTypeFields = (props)=>{
    const {displaySelectedValue,currency_code,has_currency_conversion,exchange_rate} = props;
    const hasRate = exchange_rate !== undefined && exchange_rate !== null && String(exchange_rate).trim() !== '';
    const showExchangeRate = has_currency_conversion === true && !isShowPreferredCurrencyEnabled() && hasRate;
    return(
        <Wrp>
        <span className="w-100 text-truncate"  title={displaySelectedValue}> {displaySelectedValue} </span> 

        <div className="btn-group pl-2">
          <span className="badge" data-placement="top" title="Currency" data-toggle="tooltip" style={{background: '#FFF1E0', border:'1px solid #E8B896', color: '#C2410C', fontWeight: 600, padding:'3px 10px',fontSize:'12px'}}> 
            {(currency_code===undefined || currency_code===null || currency_code==='')?'CAD':currency_code} 
          </span>
          {showExchangeRate ?
            <span className="badge" data-placement="top" title="Exchange Rate" data-toggle="tooltip" style={{background:'#E0E3EB', border:'1px solid #C5C9D4', color:'#111111', fontWeight: 600, padding:'3px 10px',fontSize:'12px'}}> 
              {formatExchangeRate(exchange_rate)} 
            </span>
          :''}
        </div>
       
      </Wrp>
    )
}

export default CurrencyTypeFields;
